<template>
  <span>
    <!--
      Self-contained trigger. Rendered only in uncontrolled mode. When a parent
      drives this via v-model (controlled mode) the trigger lives outside this
      component — e.g. a single shared modal lifted out of a virtualized table,
      so it isn't destroyed when its row is recycled on scroll.
    -->
    <template v-if="!controlled">
      <span
        v-if="notes"
        class="text-primary pointer-cursor text-truncate d-inline-block"
        style="max-width: 150px; vertical-align: bottom"
        @click="show"
      >
        {{ notes }}
      </span>
      <span v-else>-</span>
    </template>
    <modal
      :name="modalName"
      height="auto"
      :adaptive="true"
      :scrollable="true"
      :clickToClose="false"
      v-model="isOpen"
    >
      <div class="position-relative modal-outer-container">
        <div class="modal-header border-bottom">
          <div class="ml-3 pl-2">{{ title }}</div>
          <button class="btn border-0" @click="hide">
            <i class="fas fa-times fa-lg"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="notes-container">
            <input-control
              :modelValue="notes"
              wrapClass="mb-0"
              control="textarea"
              type="horizontal"
              textareaClass="border-0 auto-grow-textarea"
              labelClass="d-none"
              inputClass="disabled"
              >Notes</input-control
            >
          </div>
        </div>
      </div>
    </modal>
  </span>
</template>
<script>
export default {
  name: "NotesModal",
  data() {
    return {
      internalShow: false,
    };
  },
  props: {
    notes: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Attendance Notes",
    },
    // Undefined => uncontrolled (manages its own open state + trigger).
    // Boolean   => controlled by the parent via v-model.
    modelValue: {
      type: Boolean,
      default: undefined,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    controlled() {
      return this.modelValue !== undefined;
    },
    isOpen: {
      get() {
        return this.controlled ? this.modelValue : this.internalShow;
      },
      set(value) {
        if (this.controlled) {
          this.$emit("update:modelValue", value);
        } else {
          this.internalShow = value;
        }
      },
    },
    modalName() {
      return `notesModal_${this._uid}`;
    },
  },
  methods: {
    show() {
      this.isOpen = true;
    },
    hide() {
      this.isOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
.pointer-cursor {
  cursor: pointer;
}

.notes-container {
  max-height: min(200px, 40vh);
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #d2ddec;
  border-radius: 16px;
  padding-bottom: 8px;
  :deep(textarea.auto-grow-textarea) {
    height: auto !important;
    min-height: 80px;
    resize: none;
    overflow: hidden;
  }
}
@media (max-height: 600px) {
  .notes-container {
    max-height: min(150px, 35vh);
  }
}
</style>
